export enum RuleEnum {
  JEWELRY = "JEWELRY",
  WATCHES = "Watches",
  LEATHER_GOODS_ACCESSORIES = "LEATHER GOODS & ACCESSORIES",
  BRIDAL = "BRIDAL",
  HIGH_JEWELRY = "HIGH JEWELRY",
  HIGH_END_WATCHES = "HIGH END WATCHES",
  HIGH_END_PERFUMES = "HIGH END PERFUMES"
}
